import React, { memo } from 'react';
import { v1 as uuid } from 'uuid';
import {
  Field,
  connect as connectFormik,
  FieldProps,
  FormikProps,
} from 'formik';
import Input from 'components/Input';
import { IFormValues } from 'store/survey/surveyTypes';
import i18n from '../../../../../../../i18n';

interface IFormikConnect {
  formik: FormikProps<IFormValues>;
}

const unitId = uuid();
const numeratorId = uuid();
const denominatorId = uuid();
const numeratorUnitId = uuid();
const denominatorUnitId = uuid();

const IndicatorFields: React.FC<IFormikConnect> = () => {
  return (
    <span>
      <div className="col s6">
        <Field name="data.numerator">
          {({ field }: FieldProps) => (
            <React.Fragment>
              <Input
                type="text"
                {...field}
                id={numeratorId}
                label={i18n.t('numeratorLabel', { ns: 'survey' }) as string}
                required={true}
                placeholder={
                  i18n.t('numeratorLabel', { ns: 'survey' }) as string
                }
              />
            </React.Fragment>
          )}
        </Field>
      </div>
      <div className=" col s6">
        <Field name="data.numeratorUnit">
          {({ field }: FieldProps) => (
            <React.Fragment>
              <Input
                type="text"
                {...field}
                id={numeratorUnitId}
                label={i18n.t('numeratorUnitLable', { ns: 'survey' }) as string}
                required={true}
                placeholder={
                  i18n.t('numeratorUnitLable', { ns: 'survey' }) as string
                }
              />
            </React.Fragment>
          )}
        </Field>
      </div>
      <div className=" col s6 ">
        <Field name="data.denominator">
          {({ field }: FieldProps) => (
            <React.Fragment>
              <Input
                {...field}
                id={denominatorId}
                type="text"
                label={
                  i18n.t('denominatorLabel', {
                    ns: 'survey',
                  }) as string
                }
                placeholder={
                  i18n.t('denominatorLabel', {
                    ns: 'survey',
                  }) as string
                }
              />
            </React.Fragment>
          )}
        </Field>
      </div>
      <div className=" col s6 ">
        <Field name="data.denominatorUnit">
          {({ field }: FieldProps) => (
            <React.Fragment>
              <Input
                {...field}
                id={denominatorUnitId}
                type="text"
                label={
                  i18n.t('denominatorUnitLabel', { ns: 'survey' }) as string
                }
                placeholder={
                  i18n.t('denominatorUnitLabel', { ns: 'survey' }) as string
                }
              />
            </React.Fragment>
          )}
        </Field>
      </div>

      <Field name="data.unit">
        {({ field }: FieldProps) =>
          field.value ? (
            <div className="input-field col s12 ">
              <React.Fragment>
                <Input
                  {...field}
                  id={unitId}
                  type="text"
                  label={i18n.t('unitPlaceholder', { ns: 'survey' }) as string}
                  required={true}
                  className="validate"
                  placeholder={i18n.t('unitLabel', { ns: 'survey' }) as string}
                />
              </React.Fragment>
            </div>
          ) : (
            <div />
          )
        }
      </Field>
    </span>
  );
};

export default memo(connectFormik<any, IFormValues>(IndicatorFields));
